import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import { Editor } from '@tinymce/tinymce-react';
import { TripleDES } from 'crypto-js';



export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
    this.GS = new GlobalStorage();
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render()
  {
    return (
      <div style={{paddingTop:`70px`}}>
        <Editor
          initialValue={this.GS.getHtml()}
          init={{
            convert_urls: false,
            image_title: true, 
            automatic_uploads: true,
            file_picker_types: 'image', 
            image_caption:true,
            image_description:false,
            image_title:true,
            height: 600,    
            plugins: [
              "media advlist autolink link image code lists charmap print hr anchor",
              "searchreplace wordcount visualblocks visualchars code fullscreen  nonbreaking",
              "save table contextmenu directionality paste textcolor"
            ],            
            save_onsavecallback:(editor)=>{
                                                           
              this.GS.setHtml(editor.getContent());

              this.props.toggleModalState('createEpisode',2);
              this.props.toggleModal(true);
              
            },
            file_picker_callback: (cb, value, meta)=>{
              
              
              
                var input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                if (meta.fieldname=="multipleUpload")
                  input.setAttribute("multiple","");
                // var file;
                var length;
                var output = [];
                // Note: In modern browsers input[type="file"] is functional without 
                // even adding it to the DOM, but that might not be the case in some older
                // or quirky browsers like IE, so you might want to add it to the DOM
                // just in case, and visually hide it. And do not forget do remove it
                // once you do not need it anymore.
            
                input.onchange = function() {
                  length = (this.files.length);
                  var img = document.createElement("img");
                  
                  for (var i=0;i<=length-1;i++){                    
                    var file = this.files[i];
                    //console.log(i);
                    var reader = new FileReader();
                    reader.fileName = file.name;
                    reader.onload = function (readerEvent) {
                      
                      var image = new Image();

                      image.onload = function (imageEvent) {
                        // Resize the image
                        var canvas = document.createElement('canvas'),
                            max_size = 800,// TODO : pull max size from a site config
                            width = image.width,
                            height = image.height;
                        
                        if (width > max_size) {
                            height *= max_size / width;
                            width = max_size;
                        }
                        
                        canvas.width = width;
                        canvas.height = height;
                        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                        var dataUrl = canvas.toDataURL('image/jpeg');                      
                        output.push({
                          id:readerEvent.target.fileName,
                          src:dataUrl.replace(/^data:image\/(png|jpg);base64,/, ""),
                          // title:file.name.split('.')[0],
                          width:width,
                          height:height
                        });
                        
                        if (length==1){
                          cb(output[0].src,{title:file.name.split('.')[0],caption:true});
                        }
                        
                        if (output.length==length){
                          // console.log(output);

                            function sort_by_key(array, key)
                            {
                            return array.sort(function(a, b)
                            {
                              var x = a[key]; var y = b[key];
                              return ((x > y) ? -1 : ((x < y) ? 1 : 0));
                            });
                            }
                          output = sort_by_key(output, 'id');


                          cb("已完成縮細圖檔，請按 Insert 繼續 !",{...output});
                        }
                        
                      }
                      image.src = readerEvent.target.result;                    
                      

                      
                    };
                    reader.readAsDataURL(file);      
                  }

                  

                };
                
                

                input.click();
              },
              toolbar: "save insertfile undo redo | styleselect fontselect fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image gallery media instagram | print preview fullpage | forecolor backcolor emoticons ", 
              setup : function(editor) {
                    /*ed.on('init', function()
                    {
                        $(ed.getBody()).on('blur', function(e) {
                    var tmp = tinyMCE.activeEditor.getBody().textContent;
                            cnt(tmp);
                        });
                      $(ed.getBody()).on('keyup',function(e){
                     var tmp = tinyMCE.activeEditor.getBody().textContent;
                     cnt(tmp);
                    });
                    });*/
                    var editor_id = '';
                    editor.on('init', function (args) {
                        editor_id = args.target.id;
                    });


                    
                    // Add a button that opens a window
                    editor.ui.registry.addButton('instagram', {
                        text: 'Instagram',
                        icon: 'sourcecode',
                        onAction: function() {
                            // Open window
                            editor.windowManager.open({
                                title: 'Instagram Embed',
                                body: {
                                  type:'panel',
                                  items:[
                                    {   type: 'input',
                                        // size: 40,
                                        // height: '100px',
                                        name: 'instagram',
                                        label: 'instagram'
                                    }
                                  ],                                  
                                },
                                buttons:[
                                  {type: 'submit',text:'OK', name: 'submitButton',primary:true}
                                ],
                                onSubmit: function(api) {
                                    // Insert content when the window form is submitted
                                    var data = api.getData();
                                    // console.log(data.instagram);
                                    var embedCode = data.instagram;
                                    var script = embedCode.match(/<script.*<\/script>/)[0];
                                    var scriptSrc = script.match(/".*\.js/)[0].split("\"")[1];
                                    // console.log(script, scriptSrc);
            
                                    var sc = document.createElement("script");
                                    sc.setAttribute("src", scriptSrc);
                                    sc.setAttribute("type", "text/javascript");
            
                                    var iframe = document.getElementById(editor_id + "_ifr");
                                    var iframeHead = iframe.contentWindow.document.getElementsByTagName('head')[0];
            
                                    window.tinyMCE.activeEditor.insertContent(data.instagram);
                                    iframeHead.appendChild(sc);
                                    setTimeout(function() {
                                      iframe.contentWindow.instgrm.Embeds.process();
                                    }, 1000)
                                    editor.windowManager.close();
                                    // editor.insertContent('Title: ' + e.data.title);
                                }
                            });
                        }
                    });

                    // Add a button that opens a window
                    editor.ui.registry.addButton('gallery', {
                      text: '',
                      icon: 'gallery',
                      onAction: function() {
                          // Open window
                          editor.windowManager.open({
                              title: '上載多張圖片 (以檔名為小排先,自動排序)',
                              body: {
                                type:'panel',
                                items:[
                                  {
                                    type: 'urlinput', // component type
                                    name: 'multipleUpload', // identifier
                                    label: '', // text for the label
                                    filetype:'image',
                                  }
                                ],                                  
                              },
                              buttons:[
                                {type: 'submit',text:'Insert', name: 'submitButton',primary:true}
                              ],
                              onSubmit: function(api) {
                                var data = api.getData();
                                var d = data.multipleUpload;
                                
                                // console.log(d);
                                // console.log(d.meta);
                                // console.log(Object.keys(d.meta).length);
                                // console.log(d.meta[0]);

                                for (var i = 0; i < Object.keys(d.meta).length; i++)
                                {
                                  // editor.execCommand('mceUpdateImage', false, 
                                  //   {
                                  //     src: d.meta[i].src,
                                  //     alt: null,
                                  //     title: '',
                                  //     width: d.meta[i].width,
                                  //     height: d.meta[i].height,
                                  //     class: '',
                                  //     style: '',
                                  //     caption: false,
                                  //     hspace: '',
                                  //     vspace: '',
                                  //     border: '',
                                  //     borderStyle: '',
                                  //     isDecorative: false
                                  //   }
                                  // );
                                  
                                  editor.execCommand('mceInsertRawHTML', false, '<p style="text-align: center;"><img src="'+d.meta[i].src+'" width="'+d.meta[i].width+'" height="'+d.meta[i].height+'"/></p>');
                                  // editor.editorUpload.uploadImagesAuto();
                                }
                                api.close();
                                editor.windowManager.close();

                              }
                          });
                      }
                  });
                  

                },
              style_formats: [
                {title: "Headers", items: [
                  {title: "Header 1", format: "h1"},
                  {title: "Header 2", format: "h2"},
                  {title: "Header 3", format: "h3"},
                  {title: "Header 4", format: "h4"}
                ]},
                {title: "Inline", items: [
                  {title: "Bold", icon: "bold", format: "bold"},
                  {title: "Italic", icon: "italic", format: "italic"},
                  {title: "Underline", icon: "underline", format: "underline"},
                  {title: "Strikethrough", icon: "strikethrough", format: "strikethrough"},
                  {title: "Superscript", icon: "superscript", format: "superscript"},
                  {title: "Subscript", icon: "subscript", format: "subscript"},
                  {title: "Code", icon: "code", format: "code"}
                ]},
                {title: "Blocks", items: [
                  {title: "Paragraph", format: "p"},
                  {title: "Blockquote", format: "blockquote"},
                  {title: "Div", format: "div"},
                  {title: "Pre", format: "pre"}
                ]},
                {title: "Alignment", items: [
                  {title: "Left", icon: "alignleft", format: "alignleft"},
                  {title: "Center", icon: "aligncenter", format: "aligncenter"},
                  {title: "Right", icon: "alignright", format: "alignright"},
                  {title: "Justify", icon: "alignjustify", format: "alignjustify"}
                ]}
              ],
              font_formats: "Andale Mono=andale mono,times;"+
                "Arial=arial,helvetica,sans-serif;"+
                "Arial Black=arial black,avant garde;"+
                "Book Antiqua=book antiqua,palatino;"+
                "Comic Sans MS=comic sans ms,sans-serif;"+
                "Courier New=courier new,courier;"+
                "Georgia=georgia,palatino;"+
                "Helvetica=helvetica;"+
                "Impact=impact,chicago;"+
                "Symbol=symbol;"+
                "Tahoma=tahoma,arial,helvetica,sans-serif;"+
                "Terminal=terminal,monaco;"+
                "Times New Roman=times new roman,times;"+
                "Trebuchet MS=trebuchet ms,geneva;"+
                "Verdana=verdana,geneva;"+
                "Webdings=webdings;"+
                "Wingdings=wingdings,zapf dingbats"
          }}
          onEditorChange={this.handleEditorChange}
        />
      </div>
    )
  }
}